import { render, staticRenderFns } from "./BiddingCompanyDocument.vue?vue&type=template&id=7c427c1f&scoped=true&"
import script from "./BiddingCompanyDocument.vue?vue&type=script&lang=js&"
export * from "./BiddingCompanyDocument.vue?vue&type=script&lang=js&"
import style0 from "./BiddingCompanyDocument.vue?vue&type=style&index=0&id=7c427c1f&lang=scss&scoped=true&"
import style1 from "./BiddingCompanyDocument.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c427c1f",
  null
  
)

export default component.exports